export const pageTitle = title => {
  return (document.title = title + ' - Barzel Bank Platform');
};
